module.exports = __webpack_public_path__ + "static/media/placeholder.a9a18768.jpg";